var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "validation-observer",
        { ref: "form", attrs: { novalidate: "" } },
        [
          _c("section-title", {
            attrs: {
              "container-class": "tag-badge-main-info mt-4 mb-4",
              content: "II. Historial Psicosocial",
              icon: "fas fa-clipboard-list-check"
            }
          }),
          _c("div", { staticClass: "row" }, [
            _c("div", { staticClass: "col-12" }, [
              _vm._v(" El historial psicosocial surge de: ")
            ]),
            _c(
              "div",
              { staticClass: "col-12 row px-3 py-4" },
              [
                _vm._l(_vm.psychosocialHistoryOrigins, function(item) {
                  return _c(
                    "div",
                    { key: item?.id, staticClass: "col-12 col-md-2" },
                    [
                      _c("check-box", {
                        staticClass: "font-weight-bold",
                        class: _vm.isReadOnly ? "disabled-check" : "",
                        attrs: {
                          disabled: _vm.isReadOnly,
                          text: item.name,
                          value: Boolean(item.checked)
                        },
                        on: {
                          input: function($event) {
                            return _vm.togglePsychosocialOrigin(item?.id)
                          }
                        }
                      })
                    ],
                    1
                  )
                }),
                _c(
                  "div",
                  { staticClass: "col-12" },
                  [
                    _c("validation-provider", {
                      attrs: {
                        rules: _vm.psychosocialHistoryOrigins.some(
                          x => x.checked
                        )
                          ? ""
                          : "required"
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function({ errors }) {
                            return [
                              errors[0]
                                ? _c("error", {
                                    staticClass: "my-3",
                                    attrs: {
                                      message:
                                        "Debe seleccionar al menos una opción.",
                                      variant: "no-border"
                                    }
                                  })
                                : _vm._e()
                            ]
                          }
                        }
                      ])
                    })
                  ],
                  1
                )
              ],
              2
            ),
            _c(
              "div",
              { staticClass: "col-12" },
              [
                !_vm.isReadOnly
                  ? _c("validation-provider", {
                      attrs: { rules: "required" },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function({ errors }) {
                              return [
                                _c("custom-text-area", {
                                  attrs: {
                                    "count-classes": [
                                      "d-block",
                                      "small-counter",
                                      "text-right"
                                    ],
                                    "custom-error-msg":
                                      "El campo es requerido.",
                                    disabled: _vm.isReadOnly,
                                    error: errors[0],
                                    label:
                                      "Edad, donde vive, con quién y cómo se relaciona con su familia:",
                                    maxlength: 5000,
                                    "show-char-count": !_vm.isReadOnly
                                  },
                                  model: {
                                    value: _vm.model.personalContextInfo,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.model,
                                        "personalContextInfo",
                                        $$v
                                      )
                                    },
                                    expression: "model.personalContextInfo"
                                  }
                                })
                              ]
                            }
                          }
                        ],
                        null,
                        false,
                        3333643075
                      )
                    })
                  : _c("div", { staticClass: "d-flex flex-column" }, [
                      _c(
                        "label",
                        {
                          staticClass: "text-muted",
                          staticStyle: { "font-size": "14px" }
                        },
                        [
                          _vm._v(
                            " Edad, donde vive, con quién y cómo se relaciona con su familia: "
                          )
                        ]
                      ),
                      _c("span", [
                        _vm._v(_vm._s(_vm.model.personalContextInfo))
                      ])
                    ])
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "col-12" },
              [
                _c(
                  "label",
                  {
                    staticClass: "text-muted",
                    staticStyle: { "font-size": "14px" }
                  },
                  [
                    _vm._v(
                      " Grado que cursa, modalidad, servicios que recibe, funcionamiento académico: "
                    )
                  ]
                ),
                !_vm.isReadOnly
                  ? _c("validation-provider", {
                      attrs: { rules: "required" },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function({ errors }) {
                              return [
                                _c("custom-text-area", {
                                  attrs: {
                                    "count-classes": [
                                      "d-block",
                                      "small-counter",
                                      "text-right"
                                    ],
                                    "custom-error-msg":
                                      "El campo es requerido.",
                                    disabled: _vm.isReadOnly,
                                    error: errors[0],
                                    maxlength: 5000,
                                    "show-char-count": !_vm.isReadOnly
                                  },
                                  model: {
                                    value: _vm.model.academicInfo,
                                    callback: function($$v) {
                                      _vm.$set(_vm.model, "academicInfo", $$v)
                                    },
                                    expression: "model.academicInfo"
                                  }
                                })
                              ]
                            }
                          }
                        ],
                        null,
                        false,
                        4139005185
                      )
                    })
                  : _c("div", { staticClass: "d-flex flex-column" }, [
                      _c("span", [_vm._v(_vm._s(_vm.model.academicInfo))])
                    ])
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "col-12" },
              [
                _c(
                  "label",
                  {
                    staticClass: "text-muted",
                    staticStyle: { "font-size": "14px" }
                  },
                  [_vm._v(" Historial de salud, diagnósticos principales: ")]
                ),
                !_vm.isReadOnly
                  ? _c("validation-provider", {
                      attrs: { rules: "required" },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function({ errors }) {
                              return [
                                _c("custom-text-area", {
                                  attrs: {
                                    "count-classes": [
                                      "d-block",
                                      "small-counter",
                                      "text-right"
                                    ],
                                    "custom-error-msg":
                                      "El campo es requerido.",
                                    disabled: _vm.isReadOnly,
                                    error: errors[0],
                                    maxlength: 5000,
                                    "show-char-count": !_vm.isReadOnly
                                  },
                                  model: {
                                    value: _vm.model.healthHistory,
                                    callback: function($$v) {
                                      _vm.$set(_vm.model, "healthHistory", $$v)
                                    },
                                    expression: "model.healthHistory"
                                  }
                                })
                              ]
                            }
                          }
                        ],
                        null,
                        false,
                        3832537492
                      )
                    })
                  : _c("div", { staticClass: "d-flex flex-column" }, [
                      _c("label", {
                        staticClass: "text-muted",
                        staticStyle: { "font-size": "14px" }
                      }),
                      _c("span", [_vm._v(_vm._s(_vm.model.healthHistory))])
                    ])
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "col-12" },
              [
                _c(
                  "label",
                  {
                    staticClass: "text-muted",
                    staticStyle: { "font-size": "14px" }
                  },
                  [_vm._v(" Experiencia laboral, voluntariado: ")]
                ),
                !_vm.isReadOnly
                  ? _c("validation-provider", {
                      attrs: { rules: "required" },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function({ errors }) {
                              return [
                                _c("custom-text-area", {
                                  attrs: {
                                    "count-classes": [
                                      "d-block",
                                      "small-counter",
                                      "text-right"
                                    ],
                                    "custom-error-msg":
                                      "El campo es requerido.",
                                    disabled: _vm.isReadOnly,
                                    error: errors[0],
                                    maxlength: 5000,
                                    "show-char-count": !_vm.isReadOnly
                                  },
                                  model: {
                                    value: _vm.model.workAndVolunteerExperience,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.model,
                                        "workAndVolunteerExperience",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "model.workAndVolunteerExperience"
                                  }
                                })
                              ]
                            }
                          }
                        ],
                        null,
                        false,
                        3910509174
                      )
                    })
                  : _c("div", { staticClass: "d-flex flex-column" }, [
                      _c("span", [
                        _vm._v(_vm._s(_vm.model.workAndVolunteerExperience))
                      ])
                    ])
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "col-12" },
              [
                _c(
                  "label",
                  {
                    staticClass: "text-muted",
                    staticStyle: { "font-size": "14px" }
                  },
                  [_vm._v(" Otra información relevante: ")]
                ),
                !_vm.isReadOnly
                  ? _c("validation-provider", {
                      attrs: { rules: "required" },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function({ errors }) {
                              return [
                                !_vm.isReadOnly
                                  ? _c("custom-text-area", {
                                      attrs: {
                                        "count-classes": [
                                          "d-block",
                                          "small-counter",
                                          "text-right"
                                        ],
                                        "custom-error-msg":
                                          "El campo es requerido.",
                                        disabled: _vm.isReadOnly,
                                        error: errors[0],
                                        maxlength: 5000,
                                        "show-char-count": !_vm.isReadOnly
                                      },
                                      model: {
                                        value: _vm.model.additionalRelevantInfo,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.model,
                                            "additionalRelevantInfo",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "model.additionalRelevantInfo"
                                      }
                                    })
                                  : _vm._e()
                              ]
                            }
                          }
                        ],
                        null,
                        false,
                        1799861132
                      )
                    })
                  : _c("div", { staticClass: "d-flex flex-column" }, [
                      _c("span", [
                        _vm._v(_vm._s(_vm.model.additionalRelevantInfo))
                      ])
                    ])
              ],
              1
            )
          ])
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }